import React from 'react';
import { motion } from 'framer-motion';
import { bookInfoRo } from '../../../data/bookDataRo';
import { FiBookOpen } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const CtaSectionRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent"></div>
    <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <SafeIcon icon={FiBookOpen} className="text-brand-accent text-4xl mx-auto mb-6" />
        <blockquote className="text-2xl md:text-3xl font-display font-bold text-white leading-relaxed mb-6">
          "{bookInfoRo.closingQuote}"
        </blockquote>
        <p className="text-gray-500 mb-10">— cuvintele de închidere ale cronicii</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href={bookInfoRo.links.amazon.kindle} target="_blank" rel="noreferrer"
            className="px-8 py-4 bg-brand-accent text-brand-dark rounded-lg font-bold hover:bg-brand-accentHover transition-colors">
            Ediție Kindle
          </a>
          <a href={bookInfoRo.links.amazon.paperback} target="_blank" rel="noreferrer"
            className="px-8 py-4 bg-white/5 text-white border border-white/20 rounded-lg font-bold hover:bg-white/10 transition-colors">
            Broșată
          </a>
          <a href={bookInfoRo.links.amazon.hardcover} target="_blank" rel="noreferrer"
            className="px-8 py-4 bg-white/5 text-white border border-white/20 rounded-lg font-bold hover:bg-white/10 transition-colors">
            Cartonată
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CtaSectionRo;